import http from './http';

export interface FinancialPOAData {
  id?: string;
  hasFinancialPOA?: boolean;
  agentName?: string;
  agentContact?: string;
  agentNotified?: string;
  alternateAgentName?: string;
  alternateAgentContact?: string;
  attorneyName?: string;
  attorneyContact?: string;
  poaType?: string;
  powersGranted?: string;
  effectiveDate?: string;
  physicalLocation?: string;
  specificInstructions?: string;
  isLocked?: boolean;
}

class FinancialPOAService {
  async createFinancialPOA(data: Omit<FinancialPOAData, 'id'>): Promise<FinancialPOAData> {
    const response = await http.post('/api/financial-poa', data);
    return response.data.data || response.data;
  }

  async updateFinancialPOA(id: string, data: Partial<FinancialPOAData>): Promise<FinancialPOAData> {
    const response = await http.patch(`/api/financial-poa/${id}`, data);
    return response.data.data || response.data;
  }

  async getFinancialPOAById(id: string, targetUserId?: string): Promise<FinancialPOAData> {
    const url = targetUserId
      ? `/api/financial-poa/${id}?targetUserId=${targetUserId}`
      : `/api/financial-poa/${id}`;
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async getAllFinancialPOAs(targetUserId?: string): Promise<FinancialPOAData[]> {
    const url = targetUserId
      ? `/api/financial-poa?targetUserId=${targetUserId}`
      : '/api/financial-poa';
    const response = await http.get(url);
    return response.data.data || response.data;
  }

  async deleteFinancialPOA(id: string): Promise<void> {
    await http.delete(`/api/financial-poa/${id}`);
  }

  async lockFinancialPOA(id: string): Promise<void> {
    await http.post(`/api/financial-poa/${id}/lock`);
  }

  async unlockFinancialPOA(id: string, emails: string[]): Promise<void> {
    await http.post(`/api/financial-poa/${id}/unlock`, { emails });
  }

  async getFinancialPOAAccessGrants(id: string): Promise<any[]> {
    const response = await http.get(`/api/financial-poa/${id}/access-grants`);
    return response.data.data || response.data;
  }
}

export const financialPOAService = new FinancialPOAService();
